<template>
  <div class="modal fade md-show" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            class="close"
            type="button"
            data-dismiss="modal"
            aria-hidden="true"
          >
            <span class="s7-close"></span>
          </button>
        </div>
        <div class="modal-body">
          <div id="qrcode-wrapper" class="card">
            <div class="top-qrcode" style="">Scan to start</div>
            <div id="qrcode"></div>
            <div class="sub-qrcode">
              <div>No. <span id="code-number"></span></div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            v-on:click="print"
            class="btn btn-link btn-space btn-link-primary full"
            type="button"
          >
            {{ t("Print") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "print-js/dist/print.css";
import "print-js/dist/print.js";
import logo from "../assets/img/maprint-qrcode.png";

const QRCode = require("easyqrcodejs");
export default {
  methods: {
    open: (code) => {
      document.getElementById("code-number").innerText = code;
      document.getElementById("qrcode").innerHTML = "";
      const text = `https://app.maprint.com/?printer=${code}`;
      const color = "#000000";
      new QRCode(document.getElementById("qrcode"), {
        text: text,
        width: 500,
        height: 500,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.Q,
        dotScale: 0.6,
        logo,
        logoWidth: 150,
        logoHeight: 150,
        logoBackgroundTransparent: true,
        PI: color,
        AI: color,
        timing: "#ffffff",
      });
    },
    print: () => {
      printJS({
        printable: "qrcode-wrapper",
        type: "html",
        targetStyles: "*",
        style:
          "body { padding: 0; margin: 0 } #qrcode-wrapper { margin: 0 !important }",
      });
    },
  },
};
</script>

<style lang="scss">
#app {
  #qrcode-modal {
    #qrcode-wrapper {
      margin: 0 auto;
      color: black;
      font-family: monospace;
      width: 100%;
      max-width: 252px;
      .top-qrcode {
        font-size: 2.33em;
        margin-bottom: 15px;
        letter-spacing: 1px;
        line-height: 30px;
      }
      .sub-qrcode {
        font-size: 2.56em;
        font-family: monospace;
        letter-spacing: 5px;
        span {
          text-transform: uppercase;
          color: #000000;
        }
      }
      #qrcode {
        width: 100%;
        canvas,
        img {
          width: 100%;
        }
      }
    }
    .modal-content {
      min-width: 300px;
      width: 300px;
      margin: 0 auto;
      margin-top: 14vh;
      .modal-body {
        text-align: center;
        padding-top: unset;
        padding: 0;
      }
      .modal-footer {
        justify-content: unset;
        .btn-link {
          margin: 0 auto;
          border: 1px solid;
          font-size: 14px;
          font-weight: bold;
          text-transform: capitalize;
        }
      }
    }
  }
  .hide {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QRCode.vue